import React, {useState} from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

import TopNavbar from "./components/Nav/TopNavbar";
import Footer from "./components/Sections/Footer";
import Home from "./screens/Home";
import Login from "./screens/Login";
import Carpets from "./screens/Carpets";
import AdminDashboard from "./screens/AdminDashboard";
import CarpetDetail from "./screens/Carpet";

import styled from "styled-components";
import AboutUs from "./screens/AboutUs";
import Anleitung from "./screens/Anleitung";
import {showWarningNotification} from "./components/Elements/NotificationUtils";
import {fetchBannerText} from "./aws/DynamoDB"; // Import styled-components

export default function Main() {
    const [messageShown, setMessageShown] = useState(false);
    async function checkBannerText() {
        try {
            const bannerTest = await fetchBannerText();
            if (bannerTest && bannerTest !== "" && !messageShown) {
                showWarningNotification(bannerTest, false);
                setMessageShown(true);
            }
        } catch (error) {
            console.error('Error fetching banner text:', error);
        }
    }

// Call the function
    checkBannerText();

    return (
        <PageContainer> {/* Wrap the entire layout */}
            <TopNavbar />
            <ContentWrapper>
                <Routes>
                    <Route exact path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/carpets" element={<Carpets />} />
                    <Route path="/carpet/:id" element={<CarpetDetail />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/carpet" element={<AdminDashboard />} />
                    <Route path="/aboutUs" element={<AboutUs />} />
                    <Route path="/anleitung" element={<Anleitung />} />

                </Routes>
            </ContentWrapper>
            <FooterWrapper>
                <Footer />
            </FooterWrapper>
            <ToastContainer />

        </PageContainer>

    );
}

/* Styled Components */
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Ensures full viewport height */
`;

const ContentWrapper = styled.div`
  flex: 1; /* Pushes footer to the bottom */
  //margin-top: 60px;
`;

const FooterWrapper = styled.div`
  margin-top: auto; /* Ensures footer sticks to bottom */
  width: 100%;
`;

